<template>
  <v-container v-if="auditPeriods">
    <v-app-bar app dark dense color="secondary">
      <v-toolbar-title>{{ $t("admin.bookings.title", { year }) }}</v-toolbar-title>
    </v-app-bar>

    <BookingsTable :audit-periods="auditPeriods" :year="parseInt(year, 10)" />
  </v-container>
</template>

<script>
import AdminBookingsQuery from "@/gql/queries/admin/AdminBookingsQuery.gql";
import BookingsTable from "@/components/Admin/BookingsTable";

export default {
  components: {
    BookingsTable,
  },

  props: {
    year: {
      required: true,
    },
  },

  data() {
    return {
      users: null,
      tab: 0,
    };
  },

  apollo: {
    auditPeriods: {
      query: AdminBookingsQuery,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          year: parseInt(this.year, 10),
        };
      },
    },
  },
};
</script>
